import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import Logo from '../components/ui/Logo';

function AmazonCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const processCallback = async () => {
      try {
        const token = searchParams.get('token');
        const stores = searchParams.get('stores');
        
        if (!token) {
          throw new Error('No authentication token received');
        }
        
        console.log('✅ Received token from Amazon OAuth');
        
        // Use AuthContext helper to login with token
        const result = await loginWithToken(token);
        
        if (result.success) {
          toast.success(`✅ Logged in successfully! ${stores} store(s) accessible`, {
            duration: 4000
          });
          
          // Redirect to dashboard
          setTimeout(() => {
            navigate('/dashboard');
          }, 1000);
        } else {
          throw new Error(result.error || 'Authentication failed');
        }
        
      } catch (err) {
        console.error('❌ Amazon callback error:', err);
        setError(err.message);
        setProcessing(false);
        
        toast.error(`Login failed: ${err.message}`);
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };
    
    processCallback();
  }, [searchParams, navigate, loginWithToken]);
  
  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-red-50 flex items-center justify-center py-12 px-4">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden">
            <div className="bg-gradient-to-r from-red-600 to-red-700 px-8 py-8 text-center">
              <Logo className="justify-center mb-4" size="lg" />
              <div className="text-6xl mb-4">❌</div>
              <h1 className="text-2xl font-bold text-white">Login Failed</h1>
            </div>
            
            <div className="px-8 py-8 text-center">
              <p className="text-slate-700 mb-4">{error}</p>
              <p className="text-sm text-slate-500">Redirecting to login page...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-amber-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden">
          <div className="bg-gradient-to-r from-orange-600 to-amber-600 px-8 py-8 text-center">
            <Logo className="justify-center mb-4" size="lg" />
            <div className="text-6xl mb-4">🔄</div>
            <h1 className="text-2xl font-bold text-white">Processing Amazon Login</h1>
          </div>
          
          <div className="px-8 py-8 text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-600 mx-auto mb-6"></div>
            <p className="text-slate-700 mb-2">Verifying your Amazon credentials...</p>
            <p className="text-sm text-slate-500">Please wait a moment</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AmazonCallback;

